export default "__VITE_ASSET__BbsRebSg__"